import React, { useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import styled from 'styled-components';
import { strings } from 'strings';

import UploadImage from '../../../../../../shared/Components/UploadImage/UploadImage';
import { DeleteIcon } from '../../../../../../assets/Modal';

const DropZone = styled.div`
  border: 2px dashed #c4c4c4;
  border-radius: 8px;
  cursor: pointer;
  padding: 16px;
  text-align: center;
  background: #fafafa;
  transition: border-color 0.2s;
  &:hover {
    border-color: #888;
  }
`;

const PreviewWrapper = styled.div`
  position: relative;
`;

const DeleteBtn = styled.img`
  position: absolute;
  top: 6px;
  right: 6px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  z-index: 2;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  padding: 2px;
`;

const PreviewImg = styled.img`
  width: 100%;
  height: 140px;
  object-fit: cover;
  border-radius: 8px;
  display: block;
`;

const Label = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #555;
  margin-bottom: 6px;
`;

interface UploadThemeImageProps {
  label: string;
  imageUrl?: string | null;
  onFileChange: (file: File | null) => void;
  disabled?: boolean;
  accept?: string;
}

const UploadThemeImage: React.FC<UploadThemeImageProps> = ({
  label,
  imageUrl,
  onFileChange,
  disabled = false,
  accept = 'image/jpeg,image/png',
}) => {
  const { getRootProps, getInputProps } = useDropzone({
    accept,
    disabled,
    multiple: false,
    onDrop: (files) => {
      if (files[0]) onFileChange(files[0]);
    },
  });

  const preview = useMemo(() => imageUrl || null, [imageUrl]);

  if (preview) {
    return (
      <div>
        <Label>{label}</Label>
        <PreviewWrapper>
          <DeleteBtn
            src={DeleteIcon}
            alt="remove"
            onClick={() => !disabled && onFileChange(null)}
          />
          <PreviewImg src={preview} alt={label} />
        </PreviewWrapper>
      </div>
    );
  }

  return (
    <div>
      <Label>{label}</Label>
      <DropZone {...getRootProps()}>
        <input {...getInputProps()} />
        <UploadImage buttonText={strings.uploadImage} />
      </DropZone>
    </div>
  );
};

export default UploadThemeImage;
